import React from 'react';

export default ({ className }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
    <path fillRule="evenodd"
          d="M4.88866681,12 L4.88866681,4 L8.19335431,4 C9.99022931,4 11.1152293,5.1171875 11.1113231,6.76953125 C11.1152293,8.421875 9.96679181,9.515625 8.13476056,9.515625 L6.82226056,9.515625 L6.82226056,12 L4.88866681,12 Z M6.82226056,7.9921875 L7.77538556,7.9921875 C8.64257306,7.9921875 9.11132306,7.51953125 9.10741681,6.76953125 C9.11132306,6.0390625 8.64257306,5.55859375 7.77538556,5.55859375 L6.82226056,5.55859375 L6.82226056,7.9921875 Z"/>
  </svg>
);
